import Vue from 'vue';
import Vuex from 'vuex';
import app from "./modules/app";
import user from "./modules/user";
import permission from "./modules/permission";
import getters from "./getters";
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    app: app,
    user: user,
    permission: permission
  },
  state: {
    bgLight: false,
    projectCode: ''
  },
  mutations: {
    changeBg: function changeBg(state, params) {
      window.sessionStorage.setItem('bgLight', params);
      state.bgLight = params;
    },
    changeProject: function changeProject(state, params) {
      state.projectCode = params;
    }
  },
  actions: {},
  getters: getters
});
export default store;